import { InjectionToken } from '@angular/core';

export const HTTP_BASE_URL = new InjectionToken<string>('HTTP_BASE_URL');
